<script>
import {
  required,requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
      "services"
  ],
  data() {
    return {
      payTypeList: [],
      invoiceId : null,
      times : 1,
      type : 1,
      description:'',
      submitted: false,
      discount:0
    };
  },
  validations: {
    type: { required },
    times: {
      required: requiredIf(function () {
          return this.services.invoiceId !== null
      })
    },
  },
  watch:{
    services(){
      this.$http.post(`accounting/safebank`, { output:'only' })
      .then(resp => {
          this.payTypeList = resp.data
      })
      .catch(error => error)
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } 
        
      const { user,invoiceId } = this.services
      let postData = {}
      
      if(invoiceId){
        postData = Object.assign(postData, { invoiceId }); 
      }else{
        postData = Object.assign(postData, { times:this.times }); 
      }
      this.$http.post(`invoices/${user.id}/pay`, { ...postData, paymentChannel: this.type, paid_description:this.description, discount:this.discount })
      .then(resp => {
        if(resp.data.error) return notify.error(resp.data.message)
        this.$parent.$bvModal.hide('pay-modal')
        notify.success(resp.data.message)
      })
      
      this.submitted = false;
    },
    serviceTotal(){
      return parseFloat(this.services.invoice_items?.reduce((x, y) => parseFloat(x) + parseFloat(y.price), 0 ) * this.times) ?? 0
    },
    close(){
      this.$parent.$bvModal.hide('pay-modal')
    }
  },
};
</script>

<template>
  <b-modal id="pay-modal" title="Paket Uzat / Fatura Öde"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
         <div class="row">
          <div class="col-12">
            <h5>Hizmetler</h5>
            <div class="responsive-table"> 
                <table class="table table-hover">
                    <tbody>
                        <tr v-for="service in services.invoice_items" :key="service.id">
                            <td>{{ service.name }}</td>
                            <td class="text-end">{{ service.price }} TL  * {{ times }} </td>
                            <td class="text-end" >{{ service.price * times }} TL</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td class="text-end" colspan=2>Toplam</td> 
                            <td class="text-end" v-if="services.invoice_items">{{ serviceTotal() }} TL</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
          </div>
        </div>
        <hr>
        <!-- <div class="row">
          <div class="col">
            <div class="mb-3">
              <label for="discount">İndirim (TL)</label>
              <input
                id="discount"
                v-model="discount"
                type="text"
                class="form-control"
                placeholder="İndirim (TL)"
              />
            </div>
          </div>
        </div>-->

        <div class="row">
          <div class="col">
            <div class="mb-3">
              <label for="description">Ödeme Açıklaması</label>
              <input
                id="description"
                v-model="description"
                type="text"
                class="form-control"
                placeholder="Ödeme Açıklaması"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" v-if="!services.invoiceId">
            <div class="mb-3">
              <label for="name">Uzatılacak Ay</label>
                <select v-model="times" class="form-control form-select">
                  <option :value="f" v-for="f in 10" :key="f">{{ f }}</option>
                </select>
              <div
                v-if="submitted && !$v.times.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col">
            <div class="mb-3">
              <label for="name">Ödeme Türü</label>
              <v-select 
                v-model="type"
                :filterable="false"
                :options="payTypeList"
                label="title"
                :reduce="r => r.id">
                <span slot="no-options">Sonuç Bulunamadı</span>
              </v-select>
              <div
                v-if="submitted && !$v.type.required"
                class="invalid-feedback"
              >
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            type="submit" 
            variant="success" 
            class="ms-1"
            >{{ serviceTotal() }} TL Öde
          </b-button>
        </div>
      </form>
    </b-modal>
</template>